import React from 'react';
import { FormattedMessage } from 'react-intl';
import AccordionPanel from '@components/common/app-components/AccordionPanel';
import { faChevronRight, faChevronUp, } from '@fortawesome/free-solid-svg-icons';
import { useAppSelector } from '@hooks/index';
import { dateMethods, DATE_FORMATS } from '@utils/dates/dateMethods';
import {
    StyledUploadContainer,
    StyledVLPContainer,
    StyledVLPHeader,
    StyledVLPAccordianBody,
} from '../../../constants/styledComponents/DMIStyledComponents';

const VerificationsVLP = ({ applicantGuid }) => {
    const vlpDetails = useAppSelector(state => state.dmi.vlpVerificationsData[applicantGuid]);
    const { getDateFormatted } = dateMethods;

    const step1ResponseFields = [
        'nonCitCoaCode', 'eligStatementTxt', 'iAVTypeCode',
        'grantDate', 'agencyAction', 'fiveYearBarApplyCode',
        'qualifiedNonCitizenCode', 'fiveYearBarMetCode',
        'usCitizenCode', 'lawfulPresenceVerifiedCode',
        'aptcEnc', 'medicaidEnc',
        'responseCode', 'responseDescriptionText'
    ];

    const step2ResponseFields = [
        'majorStatement', 'minorStatement', 'grantDate',
        'resolutionData', 'agencyAction', 'fiveYearBarApplyCode',
        'lawfulPresenceVerifiedCode', 'qualifiedNonCitizenCode',
        'aptcEnc', 'medicaidEnc',
        'fiveYearBarMetCode', 'responseCode', 'responseDescriptionText'
    ];

    return (
        <StyledUploadContainer>
            {vlpDetails?.map((vlpInfo, index) => (
                <div key={index}>
                    <StyledVLPHeader>
                        <FormattedMessage id={index === 0 ? 'dmi.vlp.verifications' : 'dmi.vlp.priorVerifications'} />
                    </StyledVLPHeader>

                    {Object.entries(vlpInfo).map(([vlpKey, value], firstIndex) => (
                        <StyledVLPContainer key={`vlpAccordion_header_${vlpKey}_${firstIndex}`}>
                            <AccordionPanel
                                id={'id-panel'}
                                ariaControlsId='verificationsPanel'
                                header={
                                    <a data-testid={`#vlpAccordion_header_${vlpKey}_${firstIndex}`} >
                                        {getDateFormatted(value.step1Verifications?.[0]?.timestamp, DATE_FORMATS.MMM_DD_YYY)}
                                    </a>
                                }
                                isExpandable={true}
                                isLeftToggle={false}
                                expandedIcon={faChevronUp}
                                collapsedIcon={faChevronRight}
                            >
                                <StyledVLPAccordianBody >
                                    <div className="py-3" data-testid={`vlpAccordion_body_${vlpKey}_${firstIndex}`}>
                                        <div className="strong col-md-12">
                                            <FormattedMessage id="dmi.vlp.electronicVerifications" values={{
                                                timestamp: getDateFormatted(value.step1Verifications?.[0]?.timestamp, DATE_FORMATS.DATE_TIME_FORMAT)
                                            }} />
                                        </div>
                                        {value.step1Verifications?.length > 0 && (
                                            <div>
                                                <label className="col-sm-5">
                                                    <FormattedMessage id="dmi.vlp.immigrationCaseNumber" />
                                                </label>
                                                <label className="col-sm-7">
                                                    {value.step1Verifications?.[0]?.caseNumber}
                                                </label>
                                            </div>
                                        )}
                                        {(value.step1Verifications ?? []).map((step1Response, secondIndex) => (
                                            <div key={secondIndex}>
                                                <div className="col-sm-12 strong mt-3">
                                                    <FormattedMessage id="dmi.vlp.response1.step" values={{
                                                        timestamp: getDateFormatted(step1Response.timestamp, DATE_FORMATS.MMM_DD_YYY),
                                                        description: step1Response.responseDescriptionText
                                                    }} />
                                                </div>
                                                {step1ResponseFields.map(field => (
                                                    <>
                                                        <label className="col-sm-5">
                                                            <FormattedMessage id={`dmi.vlp.response1.${field}`} />
                                                        </label>
                                                        <label className="col-sm-7">
                                                            {step1Response[field] || 'N/A'}
                                                        </label>
                                                    </>
                                                ))}
                                            </div>
                                        ))}
                                        {(value.step2Verifications ?? []).map((step2Response, thirdIndex) => (
                                            <div key={thirdIndex}>
                                                <div className="col-sm-12 strong mt-3">
                                                    <FormattedMessage id="dmi.vlp.response2.step" values={{
                                                        timestamp: getDateFormatted(step2Response.timestamp, DATE_FORMATS.MMM_DD_YYY),
                                                        description: step2Response.responseDescriptionText
                                                    }} />
                                                </div>
                                                {step2ResponseFields.map(field => (
                                                    <>
                                                        <label className="col-sm-5">
                                                            <FormattedMessage id={`dmi.vlp.response2.${field}`} />
                                                        </label>
                                                        <label className="col-sm-7">
                                                            {step2Response[field] || 'N/A'}
                                                        </label>
                                                    </>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                </StyledVLPAccordianBody>
                            </AccordionPanel>
                        </StyledVLPContainer>
                    ))}
                </div>
            ))}
        </StyledUploadContainer >
    );
};

export default VerificationsVLP;
